import { moscowDate } from './time'
import type { ProjectSnapshot } from '../application/repository'
export interface Warning {
  id: string
  category: 'maintenance' | 'fuel' | 'stock' | 'documents' | 'work'
  severity: 'critical' | 'warning' | 'info'
  title: string
  detail: string
  equipmentId?: string
  stockId?: string
  quantity?: number
  unit?: string
  workOrderId?: string
}
export function warnings(data: ProjectSnapshot): Warning[] {
  const result: Warning[] = []
  for (const e of data.equipment) {
    const left = e.due - e.meter
    if (left <= e.alertBefore)
      result.push({
        id: 'maintenance-' + e.id,
        category: 'maintenance',
        severity: left <= 0 ? 'critical' : 'warning',
        title: e.plate + ' · ' + e.dueType,
        detail:
          left <= 0
            ? 'Регламент просрочен на ' + Math.abs(left) + ' ' + (e.meterUnit ?? 'мч')
            : 'До обслуживания ' + left + ' ' + (e.meterUnit ?? 'мч'),
        equipmentId: e.id,
      })
  }
  for (const m of data.consumables) {
    const needed = Math.max(m.required, m.reserved ?? 0)
    if (needed > m.available)
      result.push({
        id: 'stock-' + m.id,
        category: 'stock',
        severity: 'critical',
        title: m.name,
        detail: 'Не хватает ' + (needed - m.available).toLocaleString('ru-RU') + ' ' + m.unit,
        stockId: m.id,
        quantity: needed - m.available,
        unit: m.unit,
        equipmentId: m.equipmentId || undefined,
      })
  }
  for (const f of data.fuelStock) {
    if (f.balance <= f.reserved)
      result.push({
        id: 'fuel-' + f.id,
        category: 'fuel',
        stockId: f.id,
        quantity: Math.max(100, 100 + f.reserved - f.balance),
        unit: 'л',
        severity: 'critical',
        title: f.name,
        detail: 'Свободный остаток ' + (f.balance - f.reserved).toLocaleString('ru-RU') + ' л',
      })
    else if (f.balance - f.reserved < 100)
      result.push({
        id: 'fuel-' + f.id,
        category: 'fuel',
        stockId: f.id,
        quantity: Math.max(100, 100 + f.reserved - f.balance),
        unit: 'л',
        severity: 'warning',
        title: f.name,
        detail: 'Низкий свободный остаток: ' + (f.balance - f.reserved).toLocaleString('ru-RU') + ' л',
      })
  }
  const today = moscowDate()
  for (const e of data.equipment) {
    for (const [kind, date] of [
      ['Страхование', e.insuranceUntil],
      ['Диагностическая карта', e.diagnosticCardUntil],
    ]) {
      if (date && date <= today)
        result.push({
          id: 'document-' + e.id + '-' + kind,
          category: 'documents',
          severity: 'warning',
          title: e.plate + ' · ' + kind,
          detail: 'Истек срок действия документа',
          equipmentId: e.id,
        })
    }
  }
  for (const w of data.workOrders) {
    if (w.status !== 'completed' && w.status !== 'cancelled' && new Date(w.endAt) < new Date())
      result.push({
        id: 'work-' + w.id,
        category: 'work',
        severity: 'critical',
        title: w.number + ' · ' + w.title,
        detail: 'Плановый срок работы истек',
        equipmentId: w.equipmentId,
        workOrderId: w.id,
      })
  }
  return result.sort((a, b) => Number(b.severity === 'critical') - Number(a.severity === 'critical'))
}
export const workStatus: Record<string, string> = {
  planned: 'Запланировано',
  in_progress: 'В работе',
  completed: 'Завершено',
  cancelled: 'Отменено',
}
export const siteStatus: Record<string, string> = {
  active: 'Действует',
  frozen: 'Заморожен',
  completed: 'Завершен',
  planned: 'Планируется',
  archived: 'Архив',
  unverified: 'Требует проверки',
}
export const eventLabels: Record<string, string> = {
  'request.create': 'Создание заявки',
  'request.assign': 'Назначение',
  'request.schedule': 'Изменение расписания',
  'request.status': 'Статус заявки',
  'equipment.save': 'Изменение карточки',
  'equipment.baseline': 'Начальные показания',
  'equipment.service': 'Регламент ТО',
  'operator.assign': 'Закрепление оператора',
  'shift.close': 'Закрытие смены',
  'stock.issue': 'Списание',
  'stock.receive': 'Поступление',
  'maintenance.close': 'Обслуживание',
  'work.save': 'Заказ-наряд',
  'work.transition': 'Этап работы',
  'document.upload': 'Документ',
}
